import type AccessIssue from "owa-attachment-policy-access-issue-checker/lib/schema/AccessIssue";
import getConditionalAccessIssue from "owa-attachment-policy-access-issue-checker/lib/utils/getConditionalAccessIssue";
import type { MailboxInfo } from "owa-client-types";
import getModuleContextMailboxInfo from "owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo";
import { isVanityDomain } from "owa-tokenprovider";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";
import { isCapabilityEnabled } from "owa-capabilities";
import { m365AcquisitionsCapability } from "owa-capabilities-definitions/lib/m365AcquisitionsCapability";
import { trace } from "owa-trace";
import { getApplicationSettings } from "owa-application-settings";
import { isAccountExplicitLogon } from "owa-account-shared-mailbox-utils";

export function isSupportedAppServiceEnvironment(mailboxInfo?: MailboxInfo): boolean {
    // Check if the M365Acquisitions capability is enabled
    if (!isCapabilityEnabled(m365AcquisitionsCapability, mailboxInfo)) {
        trace.warn(`MOS-AppServiceNotSupported- Disabled Capability`, "addins");
        
        return false;
    }
    
    const mboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    const isExplicitLogon = isAccountExplicitLogon(mboxInfo);
    const combinedAccessIssue = getConditionalAccessIssue(mboxInfo).shift() ?? 2;
    const isVanityDomainValue = isVanityDomain();
    if (combinedAccessIssue !== 2) {
        trace.warn(`MOS-AppServiceNotSupported-
            combinedAccessIssue-${combinedAccessIssue},
            isExplicitLogon-${isExplicitLogon},
            isVanityDomain-${isVanityDomainValue}`, "addins");
    }
    
    const mosAppinVanityDomain = !isVanityDomainValue || getApplicationSettings("OwaVanityDomains").enabled;
    
    const explicitLogonSupport = isGlobalFeatureEnabled("addin-sharedMailboxNewtab")
        ? true
        : !isExplicitLogon;
    
    return (combinedAccessIssue === 2 &&
        explicitLogonSupport &&
        mosAppinVanityDomain &&
        isAccountFeatureEnabled("mos-mos3AppServiceSupportedEnv", mboxInfo));
}
